<div class="px-3">
<svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
<g id="brukerkunde.component">
<path
        id="Vector"
        d="M18.8762 11.9999C20.2327 11.9999 21.3324 10.9002 21.3324 9.54365C21.3324 8.1871 20.2327 7.0874 18.8762 7.0874C17.5196 7.0874 16.4199 8.1871 16.4199 9.54365C16.4199 10.9002 17.5196 11.9999 18.8762 11.9999Z"
        fill="#002987"
      />
<path
        id="Vector_2"
        d="M21.2486 12.9985H16.7486C15.2299 12.9985 13.9971 14.2313 13.9971 15.7501V16.2517C13.9971 16.6642 14.3346 17.0017 14.7471 17.0017H23.2502C23.6627 17.0017 24.0002 16.6642 24.0002 16.2517V15.7501C24.0002 14.2313 22.7674 12.9985 21.2486 12.9985Z"
        fill="#002987"
      />
<path
        id="Vector_3"
        d="M19.6639 4.09219C17.5358 2.22188 14.8124 1.19531 11.9999 1.19531C9.62332 1.19531 7.29363 1.94062 5.35301 3.30937L4.54207 2.54063C4.3452 2.35313 4.02176 2.45156 3.96082 2.71406L3.1452 6.09375C3.08426 6.35625 3.32801 6.59062 3.58582 6.51094L6.92332 5.52656C7.18113 5.45156 7.26082 5.12344 7.06395 4.93594L6.4452 4.35C8.09051 3.2625 10.0264 2.67188 11.9999 2.67188C14.4561 2.67188 16.8327 3.56719 18.6936 5.19844C18.8343 5.32031 19.0077 5.38125 19.1811 5.38125C19.3874 5.38125 19.5889 5.29688 19.7343 5.13281C20.0014 4.82344 19.9686 4.35938 19.6639 4.09219Z"
        fill="#002987"
      />
<path
        id="Vector_4"
        d="M20.5083 18.0045L17.0348 18.5061C16.7723 18.5436 16.6505 18.8482 16.8145 19.0545L17.4145 19.8186C15.8301 20.8029 13.9927 21.3326 12.1177 21.3326C9.6614 21.3326 7.28484 20.4373 5.4239 18.8061C5.11921 18.5389 4.65046 18.567 4.38328 18.8717C4.11609 19.1764 4.14421 19.6451 4.4489 19.9123C6.57703 21.7779 9.30046 22.8045 12.113 22.8045C14.3161 22.8045 16.477 22.1623 18.3239 20.9811L18.9801 21.8107C19.1442 22.017 19.4676 21.9701 19.5661 21.7264L20.8692 18.4686C20.9723 18.2248 20.7661 17.9623 20.5083 18.0045Z"
        fill="#002987"
      />
<path
        id="Vector_5"
        d="M23.7844 16.6357C23.7844 16.6264 23.7844 16.617 23.7844 16.6076C23.7844 14.3436 21.5859 12.5107 18.8766 12.5107C16.1672 12.5107 13.9688 14.3436 13.9688 16.6076C13.9688 16.617 13.9688 16.6264 13.9688 16.6357H23.7844Z"
        fill="#002987"
      />
<path
        id="Vector_6"
        d="M10.0361 16.6782C10.0361 16.6688 10.0361 16.6595 10.0361 16.6501C10.0361 14.386 7.8377 12.5532 5.12832 12.5532C2.41895 12.5532 0.21582 14.386 0.21582 16.6501C0.21582 16.6595 0.21582 16.6688 0.21582 16.6782H10.0361Z"
        fill="#002987"
      />
<path
        id="Vector_7"
        d="M5.12324 12.0468C6.47979 12.0468 7.57949 10.9471 7.57949 9.59053C7.57949 8.23398 6.47979 7.13428 5.12324 7.13428C3.76669 7.13428 2.66699 8.23398 2.66699 9.59053C2.66699 10.9471 3.76669 12.0468 5.12324 12.0468Z"
        fill="#002987"
      />
</g>
</svg>
</div>
